export default {
      id: "i-features-scheme-usage",
      viewBox: "0 0 731 270",
      url: __webpack_public_path__ + "img/sprite.svg#i-features-scheme",
      toString: function () {
        return this.url;
      }
    }